import React from 'react'
import { useIntl } from 'react-intl'
import { Box, Button, Divider } from '@mui/material'
import Kaspi from '../../../../../assets/img/Kaspi.png'

interface Props {
    onPay: (method: string) => void
}

const PaymentMethod: React.FC<Props> = ({ onPay }) => {
    const { formatMessage, locale } = useIntl()

    return (
        <Box
            sx={{
                background: '#FBFBFB',
                padding: 2,
                borderRadius: 2,
                display: 'grid',
                alignItems: 'start',
                gap: '16px',
                mt: 3,
            }}
        >
            <Box
                sx={{
                    padding: '8px',
                    textAlign: 'center',
                    fontWeight: 500,
                    fontSize: '20px',
                }}
            >
                {formatMessage({ id: 'completeOrder' })}
            </Box>

            <Divider sx={{ borderStyle: 'dashed' }} />

            <Button
                size="large"
                sx={{
                    background: '#fff',
                    padding: '8px',
                    border: '1px solid #EEEEEE',
                    borderRadius: 1,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: 'black',
                }}
                onClick={() => onPay('kaspi')}
            >
                <img
                    src={Kaspi}
                    alt="bank-logo"
                />
            </Button>

            <Button
                size="large"
                sx={{
                    background: '#fff',
                    border: '1px solid #EEEEEE',
                    borderRadius: 1,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontWeight: 500,
                    fontSize: '20px',
                    color: 'black',
                    textTransform: 'none',
                }}
                onClick={() => onPay('card')}
            >
                {formatMessage({ id: 'creditCard' })}
            </Button>
        </Box>
    )
}

export default PaymentMethod
